import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  clearPendingHostUserMessage,
  selectPendingHostUserMessage,
} from '../../state/aiSidekickChatSlice';

type UsePendingHostUserMessageParams = {
  isStreaming: boolean;
  sendMessage: (content: string) => boolean;
};

/**
 * Submits one queued host message through the normal chat orchestrator.
 * @param params - Active streaming state and submit callback
 */
export const usePendingHostUserMessage = ({
  isStreaming,
  sendMessage,
}: UsePendingHostUserMessageParams): void => {
  const dispatch = useDispatch();
  const pendingHostUserMessage = useSelector(selectPendingHostUserMessage);
  const consumedHostMessageIdRef = useRef<string | null>(null);

  useEffect(() => {
    if (
      pendingHostUserMessage === null ||
      isStreaming ||
      consumedHostMessageIdRef.current === pendingHostUserMessage.id ||
      !sendMessage(pendingHostUserMessage.content)
    ) {
      return;
    }

    consumedHostMessageIdRef.current = pendingHostUserMessage.id;
    dispatch(clearPendingHostUserMessage(pendingHostUserMessage.id));
  }, [dispatch, isStreaming, pendingHostUserMessage, sendMessage]);
};
